// extracted by mini-css-extract-plugin
export default {"label":"label--LE4T3"};